module.exports = __webpack_public_path__ + "static/Irisnet-4386a8f8710c9076ff3bb63fc78ef4e7.png";